import { RootState } from "../store";

export const spinnerState = (state: RootState) => state.isActive;